import './App.css';
import Apple from './Apple';

function App() {
  return (
    <div>
     <Apple/>
    </div>
  );
}

export default App;
